"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskCookieRequestAnimationFrame = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classPrivateFieldLooseBase2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseBase"));

var _classPrivateFieldLooseKey2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseKey"));

var _shallowEqual = require("../utils/shallowEqual");

var _cookie = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("cookie");

var _prevCookie = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("prevCookie");

var _task = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("task");

var _isExecuting = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("isExecuting");

var _cancelId = /*#__PURE__*/(0, _classPrivateFieldLooseKey2.default)("cancelId");

var TaskCookieRequestAnimationFrame = /*#__PURE__*/function () {
  function TaskCookieRequestAnimationFrame(cookieController) {
    (0, _classCallCheck2.default)(this, TaskCookieRequestAnimationFrame);
    Object.defineProperty(this, _cookie, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _prevCookie, {
      writable: true,
      value: {}
    });
    Object.defineProperty(this, _task, {
      writable: true,
      value: function value() {}
    });
    Object.defineProperty(this, _isExecuting, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _cancelId, {
      writable: true,
      value: 0
    });
    (0, _classPrivateFieldLooseBase2.default)(this, _cookie)[_cookie] = cookieController;
  }

  (0, _createClass2.default)(TaskCookieRequestAnimationFrame, [{
    key: "_task",
    value: function (_task2) {
      function _task() {
        return _task2.apply(this, arguments);
      }

      _task.toString = function () {
        return _task2.toString();
      };

      return _task;
    }(function () {
      var cookie = (0, _classPrivateFieldLooseBase2.default)(this, _cookie)[_cookie].get();

      if (!(0, _shallowEqual.shallowEqual)(cookie, (0, _classPrivateFieldLooseBase2.default)(this, _prevCookie)[_prevCookie])) {
        (0, _classPrivateFieldLooseBase2.default)(this, _task)[_task](cookie);

        this.setCash(cookie);
      }

      if ((0, _classPrivateFieldLooseBase2.default)(this, _isExecuting)[_isExecuting]) {
        this.execute();
      }
    })
  }, {
    key: "execute",
    value: function execute() {
      (0, _classPrivateFieldLooseBase2.default)(this, _cancelId)[_cancelId] = requestAnimationFrame(this._task.bind(this));
    }
  }, {
    key: "setCash",
    value: function setCash(cookie) {
      (0, _classPrivateFieldLooseBase2.default)(this, _prevCookie)[_prevCookie] = cookie;
    }
  }, {
    key: "setTask",
    value: function setTask(task) {
      (0, _classPrivateFieldLooseBase2.default)(this, _task)[_task] = task;
    }
  }, {
    key: "stop",
    value: function stop() {
      (0, _classPrivateFieldLooseBase2.default)(this, _isExecuting)[_isExecuting] = false;
      cancelAnimationFrame((0, _classPrivateFieldLooseBase2.default)(this, _cancelId)[_cancelId]);
    }
  }, {
    key: "start",
    value: function start() {
      if (!(0, _classPrivateFieldLooseBase2.default)(this, _isExecuting)[_isExecuting]) {
        this.execute();
        (0, _classPrivateFieldLooseBase2.default)(this, _isExecuting)[_isExecuting] = true;
        this.setCash((0, _classPrivateFieldLooseBase2.default)(this, _cookie)[_cookie].get());
      }
    }
  }]);
  return TaskCookieRequestAnimationFrame;
}();

exports.TaskCookieRequestAnimationFrame = TaskCookieRequestAnimationFrame;